import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SelectionsPage } from '@/features/owner/selections-page';

const searchSchema = z.object({
  selection: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/decisions/selections')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <SelectionsPage projectId={projectId} focus={search.selection} />;
}
